import { ColDef } from 'ag-grid-community';
import { useMemo } from 'react';
import { FieldPath } from 'react-hook-form';
import { SecurityReport, SecurityReportSchema } from '../../../schemas/SecurityReport.schema';
import { withOverrides } from '../../../util/ag-grid-utils';
import { useSchemaToGrid } from '../../../util/schema-utils';

const schema = SecurityReportSchema.gridSchema();

export function useAllSecuritiesColDefs(): ColDef<SecurityReport>[] {
  const schemaToColDef = useSchemaToGrid();

  return useMemo(() => {
    const overrides: Partial<Record<FieldPath<SecurityReport>, ColDef<SecurityReport>>> = {
      companyId: {
        initialSort: 'asc',
      },
      initialInvestmentDate: {
        // Header wraps at word boundaries; floor keeps "Investment" whole
        // beside the sort badge and header icons.
        minWidth: 200,
        initialSort: 'desc',
        headerTooltip:
          'Date of the first investment transaction for this security in this fund. For securities created by a conversion, this is the conversion date.',
      },
      // Convertible terms are blank for most securities — opt-in like the
      // Round Tracker note-term columns (FD-4242).
      valuationCap: {
        initialHide: true,
      },
      discountRate: {
        initialHide: true,
      },
    };
    return withOverrides(
      schemaToColDef(schema, [
        'companyId',
        'currentHolding',
        'initialInvestmentDate',
        'fundId',
        'investmentAmount',
        'fmv',
        'realizedValue',
        'escrow',
        'sharesHeld',
        'pps',
        'valuationCap',
        'discountRate',
      ]) as ColDef<SecurityReport>[],
      overrides
    );
  }, [schemaToColDef]);
}

export const AllSecuritiesDefaultColDefs = {
  minWidth: 170,
  flex: 1,
};

export const AllSecuritiesAutoGroupColDef = {
  sortable: true,
};
